import React from "react"
import FooterColumn from "../FooterColumn"
import FooterLink from "../FooterLink"

const Navigation = () => (
  <FooterColumn title="Navigering">
    <FooterLink to="/#home" text="Startsida" />
    <FooterLink to="/case-studies" text="Case studies" />
    <FooterLink to="/#work" text="Jobba hos oss" />
  </FooterColumn>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Footer/Navigation/index.jsx